<template>
    <div class="banner d-flex align-items-center justify-content-center" v-if="visible">
        <div class="content d-flex align-items-center justify-content-center">
            <span class="heading desktop">{{ heading }}&nbsp;<a  v-if="link && linkText" :href="link">{{ linkText }}</a></span>
            <span class="heading mobile">{{ mobileHeading }}&nbsp;<a  v-if="link && linkText" :href="link">{{ linkText }}</a></span>
            <CountdownTimer class="desktop" v-if="endDate" :endDate="endDate" @timerEnded="closeOnEndDate"/>
            
            
        </div>
        <img class="close-icon" src="@/assets/images/home/close-icon.svg" @click="closeBanner"/>
    </div>
</template>
<script setup>
	import { onMounted, ref, defineProps, inject, defineEmits } from 'vue'
	import CountdownTimer from '@/components/shared/CountdownTimer'
    const CLOSED = 'closed'

    const stanAnalytics = inject('stanAnalytics')
	const emit = defineEmits('toggle')
    const props = defineProps({
            bannerKey: {
                type: String,
            },
            heading: {
                type: String,
            },
            mobileHeading: {
                type: String,
            },
            endDate: {
                type: Date,
                default: undefined
            },
            hideOnEndDate: {
                type: Boolean,
                default: false
            },
            linkText: {
                type: String,
            },
            link: {
                type: String,
            },
        })
    const visible =  ref(false)

    onMounted(() => {
        setVisible(props.bannerKey && !(sessionStorage.getItem(props.bannerKey) === CLOSED))
    })

    const closeOnEndDate = () => {
        stanAnalytics('banner-time-expired', {
                meta: { username: 'guest'},
                props: { bannerKey: props.bannerKey },
            })

        if (props.hideOnEndDate) {
            stanAnalytics('banner-closed-expired', {
                meta: { username: 'guest'},
                props: { bannerKey: props.bannerKey },
            })

            sessionStorage.setItem(props.bannerKey, CLOSED)
            setVisible(false)
        }
    }

    const closeBanner = () => {
        sessionStorage.setItem(props.bannerKey, CLOSED)
        setVisible(false)

        stanAnalytics('banner-closed-by-user', {
                meta: { username: 'guest'},
                props: { bannerKey: props.bannerKey },
            })
    }

    const setVisible = (newStatus) => {
        if (newStatus) {
            stanAnalytics('banner-visible', {
                meta: { username: 'guest'},
                props: { bannerKey: props.bannerKey },
            })
        }
        if (newStatus !== visible.value) {
            visible.value = newStatus
            emit('toggle', newStatus)
        }
    }


</script>

<style lang="scss" scoped>
    .banner {
        background: #30ffb4;
        min-height: 66px;
        padding-left: 25px;
        padding-right: 25px;
        font-size: 18px;


        .desktop {
            display: block;
        }
        .mobile {
            display: none
        }

        .close-icon {
            cursor: pointer;
            margin-left: 25px;
        }

        @media screen and (max-width: 767px) {
            padding-left: 20px;
            padding-right: 20px;
            font-size: 14px;

            .desktop {
                display: none;
            }
            .mobile {
                display: block;
            }

            .close-icon {
                margin-left: 10px;
                height: 17px;
            }
        }

        .content {
            gap: 10px;
            margin: 0 auto;
        }

        .heading {
            color: var(--Text-Dark);
            font-family: "Plus Jakarta Sans";
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            letter-spacing: -0.36px;
        }

        a:link {
            color: var(--Text-Dark, #131F60);
            font-family: "Plus Jakarta Sans";
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            letter-spacing: -0.36px;
            text-decoration-line: underline;
            text-decoration-style: solid;
            text-decoration-skip-ink: auto;
            text-decoration-thickness: auto;
            text-underline-offset: auto;
            text-underline-position: from-font;
        }

      

    }
</style>